import { ChangeDetectorRef, Injectable } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { DataConnectorType, DataConnector, FileDataConnector } from 'src/app/domainObjects/dataConnector';
import { DataSourceType } from 'src/app/domainObjects/dataSourceType';
import { IngestConfigViewModel } from 'src/app/views/import-data/import-data.component';
import { FileBrowserDialogComponent } from 'src/app/views/file-browser-dialog/file-browser-dialog.component';
import { DataConnectorViewModel } from 'src/app/viewModels/dataConnectorViewModel';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { ConfigService } from 'src/app/services/config/config.service';
import { BaseComponent } from 'src/app/base/base.component';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedService } from 'src/app/services/shared.service';
import { UserDataService } from 'src/app/services/user-data-service';
// import { IngestParametersSetting, IngestParametersSettings } from 'src/app/domainObjects/masterConfig';
import { FolderBrowserDialogComponent } from 'src/app/views/folder-browser-dialog/folder-browser-dialog.component';
import { DatePipe } from '@angular/common';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { SortBuilderComponent } from 'src/app/views/transform/sort-builder/sort-builder.component';
import { TransformerParametersViewModel } from 'src/app/views/transform/transformerDetail/transformer-parameters/transformerParametersViewModel';
import { DataDictionaryType } from 'src/app/domainObjects/dataDictionaryType';
import { OptionItem } from 'src/app/model/optionItem';
import { DataDictionaryItem, DataDictionaryService } from 'src/app/services/dataDictionary/data-dictionary.service';
import { ParameterSetting } from 'src/app/domainObjects/masterConfig';
import { DataFarmType } from 'src/app/domainObjects/dataFarmType';
import { DurationBuilder, DurationUnits, DurationUnitsUtil } from 'src/app/domainObjects/ingestTransforms';
import { FarmConverterRule } from 'src/app/domainObjects/transformers/farmConverterTransform';
//import { IngestTransformsConfigViewModel } from 'src/app/views/import-data-ingest/import-data-ingest.component';

//import { DataTransformerConfig, IngestTransformerConfig } from 'src/app/domainObjects/dataTransformConfig';


@Component({
    selector: 'app-durationcalcs-data-connector',
    templateUrl: './durationcalcs-data-connector.component.html',
    styleUrls: ['./durationcalcs-data-connector.component.css'],
    standalone: false
})
export class DurationcalcsDataConnectorComponent extends BaseComponent implements OnInit {
  @Input() dataSourceType: DataSourceType;
  @Input() dataTransformConfigViewModel: DataTransformConfigViewModel;
  //@Input() viewModel: TransformerParametersViewModel;
  @Input() ingestConfig: IngestConfigViewModel;

 DurationUnitsUtil = DurationUnitsUtil;
  DurationUnits = DurationUnits;
  DurationUnitTypes = [
    DurationUnits.m,
    DurationUnits.s,
    DurationUnits.ms,
    DurationUnits.us,
    DurationUnits.ns
  ];
  
 viewModel: DurationBuilder;

 sortCtrl = new UntypedFormControl('');
 selectedTargetColumns: OptionItem[] = [];
  dataDictionaryItems: DataDictionaryItem[] = [];
  data: any = {
    columnMap: [
      // Example structure of your JSON data
      // {
      //   "sourceColumnName": "Column1",
      //   "targetColumnName": "TargetColumn1"
      // },
      // Add your actual data here
    ]
  };
  sortedColumns: any[] = [];
  eventStartFields: Array<string>;
  durationFields: Array<string>;
  
  constructor(
    matDialog: MatDialog,
    private dataDictService: DataDictionaryService,
    private userData: UserDataService,private configService: ConfigService,private cdRef: ChangeDetectorRef,
    errorLogger: ErrorReportingService) {
      super(errorLogger, matDialog);
    }

  async ngOnInit(): Promise<void> {
    this.viewModel =this.dataTransformConfigViewModel.DurationBuilder;
    var farmtypeid=this.userData.getSelectedNodeDetails().farmtypeid;
    
    if(farmtypeid==1){//Subtask
      var dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.subTask);
      this.eventStartFields=dataDictionaryItems.filter(x=>x.DataType=='Timestamp').map( i => i.Field).sort();
      this.durationFields=dataDictionaryItems.filter(x=>x.DataType=='Duration').map( i => i.Field).sort();
    }else if(farmtypeid==2){//Task
      var dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.task);
      this.eventStartFields=dataDictionaryItems.filter(x=>x.DataType=='Timestamp').map( i => i.Field).sort();
      this.durationFields=dataDictionaryItems.filter(x=>x.DataType=='Duration').map( i => i.Field).sort();
    }
    else if(farmtypeid==3){//Activity
      var dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.activity);
      this.eventStartFields=dataDictionaryItems.filter(x=>x.DataType=='Timestamp').map( i => i.Field).sort();
      this.durationFields=dataDictionaryItems.filter(x=>x.DataType=='Duration').map( i => i.Field).sort();
    }
    else if(farmtypeid==6){//Behavior
      var dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.behavior);
      this.eventStartFields=dataDictionaryItems.filter(x=>x.DataType=='Timestamp').map( i => i.Field).sort();
      this.durationFields=dataDictionaryItems.filter(x=>x.DataType=='Duration').map( i => i.Field).sort();
    }
    // var dataDictionaryItems = this.dataTransformConfigViewModel.dataTransformerConfig.dataConnectorMappings.find(x=>x.guid==this.dataTransformConfigViewModel.selectedIngestFarmGuid).columnMap;
    // this.eventStartFields=dataDictionaryItems.filter(x=>x.dataType=='Timestamp').map( i => i.targetColumn).sort();
    // this.durationFields=dataDictionaryItems.filter(x=>x.dataType=='Duration').map( i => i.targetColumn).sort();

    if (this.viewModel.farmType==0) {
      var eventStartField ="";
      var eventEndField ="";
      var durationField ="";
      //const sortInfo: SortInfo[]=[];
      if(farmtypeid==1){//Subtask
        eventStartField ="subtaskTimestamp";
        eventEndField ="subtaskTimestamp";
        var durationFieldDefault ="subtaskDuration;subtaskDuration2";
        for(let pr of durationFieldDefault.split(";")){
          const foundColumn = this.durationFields.find(sc => sc == pr);
          if(foundColumn){
            durationField=foundColumn;
            break;
          }
        }
        //sortInfo.push({ sortField: "userId", sortAscending: true });
        //sortInfo.push({ sortField: "subtaskTimestamp", sortAscending: true });
      }else if(farmtypeid==2){//Task
        var eventStartField ="taskStart";
        var eventEndField ="taskEnd";
        var durationFieldDefault ="taskDuration;taskDuration2";
        for(let pr of durationFieldDefault.split(";")){
          const foundColumn = this.durationFields.find(sc => sc == pr);
          if(foundColumn){
            durationField=foundColumn;
            break;
          }
        }
        //sortInfo.push({ sortField: "userId", sortAscending: true });
        //sortInfo.push({ sortField: "taskEnd", sortAscending: true });
      }
      else if(farmtypeid==3){//Activity
        var eventStartField ="activityStart";
        var eventEndField ="activityEnd";
        var durationFieldDefault ="activityDuration;callDuration;activityDuration2";
        for(let pr of durationFieldDefault.split(";")){
          const foundColumn = this.durationFields.find(sc => sc == pr);
          if(foundColumn){
            durationField=foundColumn;
            break;
          }
        }
        //sortInfo.push({ sortField: "userId", sortAscending: true });
        //sortInfo.push({ sortField: "activityEnd", sortAscending: true });
      }
      else if(farmtypeid==6){//Behavior
        var eventStartFieldDefault ="behaviourDateTime1;behaviourDateTime2";
        var eventEndFieldDefault ="endTime;behaviourDateTime1;behaviourDateTime2";
        var durationFieldDefault ="behaviourDuration1;behaviourDuration2";
        for(let pr of eventStartFieldDefault.split(";")){
          const foundColumn = this.eventStartFields.find(sc => sc == pr);
          if(foundColumn){
            eventStartField=foundColumn;
            break;
          }
        }
        for(let pr of eventEndFieldDefault.split(";")){
          const foundColumn = this.eventStartFields.find(sc => sc == pr);
          if(foundColumn){
            eventEndField=foundColumn;
            break;
          }
        }
        for(let pr of durationFieldDefault.split(";")){
          const foundColumn = this.durationFields.find(sc => sc == pr);
          if(foundColumn){
            durationField=foundColumn;
            break;
          }
        }
        //sortInfo.push({ sortField: "userId", sortAscending: true });
        //sortInfo.push({ sortField: "endTime", sortAscending: true });
      }
      this.viewModel = new DurationBuilder(farmtypeid, DurationUnits.s, eventStartField, eventEndField, durationField, false);//, sortInfo
      this.dataTransformConfigViewModel.DurationBuilder=this.viewModel;
    }
    //fot sort
    this.selectedTargetColumns = this.ingestConfig.columnMap
    .filter(column => column.targetColumnName)  // Filter out empty or null targetColumnNames
    .map((column, index) => new OptionItem(index, column.targetColumnName)); // Map to OptionItem with id and text
    if(this.viewModel.runIngestDuration){
      this.validateField();
    }
  }

  ngOnChanges(changes: any) {
     this.viewModel =this.dataTransformConfigViewModel.DurationBuilder;
  }
 
//  removeSortInfo(sortInfo: SortInfo): void {
//     const index = this.viewModel.sortInfo?.indexOf(sortInfo);
//     if (index >= 0) {
//       this.viewModel.sortInfo?.splice(index, 1);
//     }
//   }

  // showSortBuilder(): void {
  //   const dialog = this.matDialog.open(SortBuilderComponent, {
  //     data: {
  //       fields: this.selectedTargetColumns.map(c => c.text),
  //       sortItems: this.viewModel.sortInfo.map(item => ({ ...item }))//[...this.viewModel.sortInfo ?? []] // make copy of array so it doesn't edit actual list
  //     }
  //   });

  //   dialog.afterClosed().subscribe(result => {
  //     if (!result) {
  //       return;
  //     }
  //     const items = result.sortItems;
  //     //this.sortInfo = items;
  //     this.viewModel.sortInfo = items;
  //     //this.viewModel.sortInfoDisplay = this.viewModel.sortInfo.map(i => `${i.sortField} (${i.sortAscending ? 'asc' : 'desc'})}`).join(',');
  //     this.sortCtrl.setValue(null);
  //   });
  // }
  validateField(): void{
    var columnMaps = this.dataTransformConfigViewModel.dataTransformerConfig.dataConnectorMappings.find(x=>x.guid==this.dataTransformConfigViewModel.selectedIngestFarmGuid).columnMap || [];
    var timestampCount=columnMaps.filter(x=>x.dataType=='Timestamp').length;
    var durationCount=columnMaps.filter(x=>x.dataType=='Duration').length;
    let durationCalcsValid = true;

    if (timestampCount >= 2 || (timestampCount === 1 && durationCount === 1)) {
      durationCalcsValid = false;
    }
    if(durationCalcsValid){
      setTimeout(() => {
        this.viewModel.runIngestDuration = false;
      });
      this.cdRef.detectChanges();
      this.displayWarning("Two of the three Duration Builder fields must be selected in the Column Mapper.","Duration Calcs Info");
    }
  }
}
